__turbopack_context__.v({
  "className": "asimovian_56ee9c66-module__Kh7Gvq__className",
});
